import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["option"]

  connect() {
    console.log("SelectVisibilityController connected")
    this.toggle()
  }

  toggle() {
    console.log("Toggling select visibility")
    // Trouve le select dans la portée du contrôleur
    const selectElement = this.element.querySelector("select")
    if (!selectElement) {
      console.log("No select element found")
      return
    }
    
    const selectedValue = selectElement.value
    console.log("Selected value:", selectedValue)
    
    this.optionTargets.forEach(option => {
      const optionValue = option.dataset.option
      console.log("Checking option:", optionValue, "against selected:", selectedValue)
      
      if (optionValue === selectedValue && selectedValue !== "") {
        option.classList.remove("hidden")
        // Activer les champs dans cette option
        const inputs = option.querySelectorAll("input, select, textarea")
        inputs.forEach(input => {
          input.disabled = false
        })
        console.log("Showing option:", optionValue)
      } else {
        option.classList.add("hidden")
        // Désactiver les champs dans cette option pour éviter qu'ils soient soumis
        const inputs = option.querySelectorAll("input, select, textarea")
        inputs.forEach(input => {
          input.disabled = true
        })
        console.log("Hiding option:", optionValue)
      }
    })
  }
}
